import React from 'react';
import { Button, Box } from '@mui/material';
import { StorefrontOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function ApplyButton({ profile }) {
  const navigate = useNavigate();

  const handleApply = () => {
    navigate(`/app/retail-booking/${profile.id}`);
  };

  const hasAvailableSlots = profile?.schedules?.some((schedule) => schedule.slots_available > 0);

  return (
    <Box mt={3}>
      <Button
        variant="contained"
        fullWidth
        size="large"
        startIcon={<StorefrontOutlined />}
        onClick={handleApply}
        disabled={!hasAvailableSlots || profile?.status !== 'active'}
        sx={{
          bgcolor: '#EE7B57',
          py: 1.5,
          fontSize: '1rem',
          fontWeight: 'bold',
          '&:hover': {
            bgcolor: '#d66a47',
          },
          '&:disabled': {
            bgcolor: '#CCC',
          },
        }}>
        {hasAvailableSlots && profile?.status === 'active'
          ? 'Apply for This Space'
          : 'No Slots Available'}
      </Button>
    </Box>
  );
}

ApplyButton.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
    schedules: PropTypes.arrayOf(
      PropTypes.shape({
        slots_available: PropTypes.number,
      }),
    ),
  }).isRequired,
};
